import ChargebeeAddon from '../../calculator/ChargebeeAddon'
import getF25PlanPricing from '../../calculator/getF25Pricing'
import { Pricing } from '../../types'
import Feature from '../Feature'
import PlanVariant from '../PlanVariant'
import { PlanTypeEnum } from '../types'
import {
  DATO_PLAN_DESCRIPTION_FIELD,
  DATO_PLAN_ID_FIELD,
  DATO_PLAN_TITLE_FIELD,
  DEFAULT_ICON,
  PRO_PLAN_TYPE,
  STARTER_PLAN_TYPE,
  getVariantFromID,
} from '../utils'

export function initF25PlanVariants(rawBundles: Pricing, country: string) {
  const f25PlanVariants: PlanVariant[] = []

  const nonCorePlans = rawBundles.allF25Plans.filter((f25Plan) => !f25Plan.isCorePlan)

  nonCorePlans.forEach((f25Plan) => {
    const features = f25Plan.regions[0].features.map(
      (feature) => new Feature(feature.title, feature.tooltip, feature.highlightInModules || false)
    )
    const matchedPack = rawBundles.pricingF25PlanStructure.packs.find(
      (pack) => pack.title === f25Plan.title
    )
    const includedAddons = matchedPack?.business?.f25NormalPlans
    const includedExtraAddons = matchedPack?.business?.f25ExtraAddons

    const chargebeeAddons = f25Plan.regions[0].chargebeePlans.map((addon) => {
      return new ChargebeeAddon(
        addon.planId,
        addon.currencyCode,
        addon.period,
        addon.periodUnit,
        addon.pricingModel,
        addon.chargeType,
        addon.selectedCountries,
        addon.price,
        addon.tiers
      )
    })

    const pricing = getF25PlanPricing(chargebeeAddons, country)

    // If there is no compatible pricing, ignore this plan
    if (!pricing) return

    const planType: PlanTypeEnum = /\bPro\b/.test(f25Plan[DATO_PLAN_ID_FIELD])
      ? PRO_PLAN_TYPE
      : STARTER_PLAN_TYPE

    const variantOptions = {
      id: f25Plan[DATO_PLAN_ID_FIELD],
      title: f25Plan[DATO_PLAN_TITLE_FIELD],
      type: getVariantFromID(f25Plan[DATO_PLAN_ID_FIELD]),
      description: f25Plan[DATO_PLAN_DESCRIPTION_FIELD],
      icon: DEFAULT_ICON,
      features,
      pricing,
      planType,
      includedAddons,
      includedExtraAddons,
    }
    const variant = new PlanVariant(variantOptions)

    f25PlanVariants.push(variant)
  })

  return f25PlanVariants
}
